// Library Imports
import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'

// Component Imports
import ListingSearch from './ListingSearch'

// Asset Imports
import BottomLogo from '../../assets/images/BottomLogo.png'
import '../../assets/css/stylesheets/pages/Home/Home.css'
import CategoryCards from './CategoryCards'

function Home() {
    return (
        <>
            <Container fluid className='homepage'>
                <Row>
                    <Col>
                        <div className='homepage-subheading'>Your Web Guide To Jersey Breeders & Allied Industry</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className='homepage-heading'>Discover the Possibilities</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Image src={BottomLogo} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ListingSearch />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CategoryCards />
                    </Col>
                </Row>
            </Container>
        </>

    )
}

export default Home